import React from "react";
import { Bot, Sparkles, Mic, ArrowRight } from "lucide-react";

// Brand ink for the Riya hero band (matches the landing dark sections).
const INK = "hsl(164 33% 7%)";

/**
 * "Experience SearchJob.ai in Action" banner for Riya, the live AI hiring
 * consultant. Shared by the demo gallery and the booking page so the copy lives
 * in ONE place. `onStart` fires when the visitor clicks "Start AI Demo".
 */
export default function DemoBanner({ onStart, showCta = true, showTiming = true }) {
  return (
    <div
      className="relative overflow-hidden rounded-3xl p-8 md:p-10 shadow-xl"
      style={{ backgroundColor: INK }}
    >
      <div className="absolute -right-16 -top-16 w-64 h-64 rounded-full bg-primary/20 blur-3xl" />
      <div className="relative flex flex-col md:flex-row items-start md:items-center gap-6 md:gap-8">
        <div className="relative shrink-0">
          <div className="absolute inset-0 rounded-full bg-primary/40 animate-ping" />
          <div className="relative w-20 h-20 rounded-full bg-primary flex items-center justify-center shadow-lg">
            <Bot size={40} className="text-primary-foreground" />
          </div>
        </div>
        <div className="flex-1">
          <div className="inline-flex items-center gap-2 text-white text-xs font-semibold tracking-wide mb-2">
            <Sparkles size={14} className="text-emerald-400" /> MEET RIYA · AI HIRING CONSULTANT
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-white leading-tight">
            Experience SearchJob.ai in Action
          </h2>
          <p className="text-white/85 mt-2 max-w-2xl text-sm md:text-base leading-relaxed font-medium">
            Discover how AI can transform your hiring{showTiming ? " — in just ~2 minutes" : ""}.
          </p>
          <p className="text-white/70 mt-2 max-w-2xl text-sm md:text-base leading-relaxed">
            Meet our AI Hiring Consultant for a live, personalized conversation. Tell us about your
            hiring needs and see how SearchJob.ai helps you identify top talent, faster.
          </p>
          {showTiming && (
            <div className="flex items-center gap-2 mt-3 text-white/60 text-xs font-medium">
              <Mic size={13} className="text-primary" />
              <span>Live AI conversation · ~2 minutes · Personalized to your organization</span>
            </div>
          )}
        </div>
        {showCta && (
          <button
            onClick={onStart}
            className="shrink-0 inline-flex items-center gap-2 rounded-full bg-primary text-primary-foreground px-7 py-3.5 font-semibold shadow-lg hover:bg-primary/90 transition"
          >
            <Mic size={18} /> Start AI Demo <ArrowRight size={16} />
          </button>
        )}
      </div>
    </div>
  );
}
